// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 后台用户列表（分页） 查询后台用户列表（分页、过滤、排序）。

需已登录管理端。支持按状态过滤、关键词搜索用户名/昵称，排序符合 ProTable 规范。
非系统管理员调用时，自动过滤掉系统管理员角色用户及用户名以 __system 开头、以 __ 结尾的用户。 GET /api/admin/users */
export async function listAdminUsersApiAdminUsersGet(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.listAdminUsersApiAdminUsersGetParams,
  options?: { [key: string]: any }
) {
  return request<API.PaginatedResponseAdminUserResponse_>("/api/admin/users", {
    method: "GET",
    params: {
      // current has a default value: 1
      current: "1",
      // pageSize has a default value: 10
      pageSize: "10",
      ...params,
    },
    ...(options || {}),
  });
}

/** 创建后台用户 创建后台用户。

仅系统管理员或运营管理员可调用。可指定用户名、密码、昵称、状态（active/inactive）、角色。
用户名唯一，密码至少 8 位。分配 system_admin 角色仍仅系统管理员可操作。 POST /api/admin/users */
export async function createAdminUserApiApiAdminUsersPost(
  body: API.CreateAdminUserRequest,
  options?: { [key: string]: any }
) {
  return request<API.BaseResponseAdminUserResponse_>("/api/admin/users", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取后台用户详情 获取指定后台用户详情。需已登录管理端，是否可访问由前端按权限点控制。 GET /api/admin/users/${param0} */
export async function getAdminUserDetailApiAdminUsersUserIdGet(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getAdminUserDetailApiAdminUsersUserIdGetParams,
  options?: { [key: string]: any }
) {
  const { user_id: param0, ...queryParams } = params;
  return request<API.BaseResponseAdminUserResponse_>(
    `/api/admin/users/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新后台用户 更新指定后台用户（角色、状态、昵称、头像）。

仅系统管理员或运营管理员可调用。不能修改自己的角色。仅传需要修改的字段。分配 system_admin 仍仅系统管理员可操作。 PUT /api/admin/users/${param0} */
export async function updateAdminUserApiApiAdminUsersUserIdPut(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.updateAdminUserApiApiAdminUsersUserIdPutParams,
  body: API.UpdateAdminUserRequest,
  options?: { [key: string]: any }
) {
  const { user_id: param0, ...queryParams } = params;
  return request<API.BaseResponseAdminUserResponse_>(
    `/api/admin/users/${param0}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除后台用户 删除指定后台用户（软删除）。

需已登录管理端。不能删除自己。是否可访问由前端按权限点控制。 DELETE /api/admin/users/${param0} */
export async function deleteAdminUserApiApiAdminUsersUserIdDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteAdminUserApiApiAdminUsersUserIdDeleteParams,
  options?: { [key: string]: any }
) {
  const { user_id: param0, ...queryParams } = params;
  return request<API.BaseResponseDict_>(`/api/admin/users/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 重置后台用户密码 重置指定后台用户的密码。

需已登录管理端。不需要旧密码，直接设置新密码（至少 8 个字符）。是否可访问由前端按权限点控制。 PUT /api/admin/users/${param0}/password */
export async function resetAdminUserPasswordApiApiAdminUsersUserIdPasswordPut(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.resetAdminUserPasswordApiApiAdminUsersUserIdPasswordPutParams,
  body: API.ResetAdminUserPasswordRequest,
  options?: { [key: string]: any }
) {
  const { user_id: param0, ...queryParams } = params;
  return request<API.BaseResponseDict_>(`/api/admin/users/${param0}/password`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** 管理端用户登录 管理端用户密码登录

验证用户名和密码，返回 JWT Token。
此接口不需要认证。 POST /api/admin/users/login */
export async function adminLoginApiAdminUsersLoginPost(
  body: API.AdminLoginRequest,
  options?: { [key: string]: any }
) {
  return request<API.BaseResponseAdminLoginResponse_>(
    "/api/admin/users/login",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取当前管理端用户信息 获取当前登录的管理端用户信息 GET /api/admin/users/me */
export async function getCurrentAdminUserInfoApiAdminUsersMeGet(options?: {
  [key: string]: any;
}) {
  return request<API.BaseResponseAdminUserResponse_>("/api/admin/users/me", {
    method: "GET",
    ...(options || {}),
  });
}

/** 更新个人信息 更新当前管理端用户的个人信息

只能修改昵称和头像，不能修改 telegram_user_id。 PUT /api/admin/users/me */
export async function updateProfileApiAdminUsersMePut(
  body: API.UpdateProfileRequest,
  options?: { [key: string]: any }
) {
  return request<API.BaseResponseAdminUserResponse_>("/api/admin/users/me", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取当前后台用户角色权限信息 获取当前后台用户授权信息（角色、权限点、菜单）。 GET /api/admin/users/me/authz */
export async function getCurrentAdminUserAuthzApiAdminUsersMeAuthzGet(options?: {
  [key: string]: any;
}) {
  return request<API.BaseResponseAdminUserAuthzResponse_>(
    "/api/admin/users/me/authz",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 生成 Telegram 绑定链接 为当前管理端用户生成 Telegram 绑定链接

链接有效期为 1 小时，一次性使用。用户点击链接后会自动触发绑定操作。 GET /api/admin/users/me/bind-telegram-link */
export async function generateBindTelegramLinkApiAdminUsersMeBindTelegramLinkGet(options?: {
  [key: string]: any;
}) {
  return request<API.BaseResponseBindTelegramLinkResponse_>(
    "/api/admin/users/me/bind-telegram-link",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 修改密码 修改当前管理端用户的密码

需要提供旧密码进行验证，新密码至少需要 8 个字符。 PUT /api/admin/users/me/password */
export async function changePasswordApiAdminUsersMePasswordPut(
  body: API.ChangePasswordRequest,
  options?: { [key: string]: any }
) {
  return request<API.BaseResponseDict_>("/api/admin/users/me/password", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询绑定的 Telegram 用户信息 查询当前管理端用户绑定的 Telegram 用户信息

如果未绑定，返回的 data 为 null。 GET /api/admin/users/me/telegram-user */
export async function getTelegramUserInfoApiAdminUsersMeTelegramUserGet(options?: {
  [key: string]: any;
}) {
  return request<API.BaseResponseTelegramUserInfoResponse_>(
    "/api/admin/users/me/telegram-user",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}
